import { render, staticRenderFns } from "./geoarea.vue?vue&type=template&id=33f6315b&"
import script from "./geoarea.vue?vue&type=script&lang=js&"
export * from "./geoarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports